var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLight01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.9,12.4c-2.4,0.1-4.5-1.7-4.6-4.1C3.2,5.8,5.1,3.8,7.5,3.6c0.2,0,0.3,0,0.5,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 8,
    y1: 13,
    x2: 8,
    y2: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 8.2,
    cy: 7.9,
    rx: 4.5,
    ry: 4.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLight01);
export default __webpack_public_path__ + "static/media/ExternalLight-01.ab62044b368a3798927dc45ef7d138d0.svg";
export { ForwardRef as ReactComponent };